import * as R from "ramda";

import { uploadOpportunityDocument } from "../../store/actions/opportunity";

const uploadChatbotDocuments = async (opportunityId, chatbot, dispatch) => {
  const documentQuestions = R.filter(
    R.propIs(File, "document"),
    R.pathOr([], ["config", "chatTree", "questions"], chatbot)
  );

  await Promise.all(
    documentQuestions.map(async question => {
      const { location } = await dispatch(
        uploadOpportunityDocument({
          id: opportunityId,
          file: question.document
        })
      );
      question.document = location;
    })
  );
};

export default uploadChatbotDocuments;
